import styled from '@emotion/styled';
import { KayWoodProps } from './KayWood';

export const StyledKayWood = styled.div<KayWoodProps & { scale?: number }>(({ top = '0', bottom = 'auto', left = '0', right = 'auto', scale = 1 }) => ({
	position: 'absolute',
	top,
	bottom,
	left,
	right,
	willChange: 'transform',
	pointerEvents: 'none',
	userSelect: 'none',

	'.lottie': {
		width: `max(${Math.round(300 * scale)}px, ${Math.round(46 * scale)}vw)`,
		height: 'auto',
	},
}));
